import { BLACK_LIST } from "constants/validate";
import store from "store/store";

export const isValidPwd = (pwd) => {
    if (!pwd) return false
    var re = /^((?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9]).{7,31})\S$/mg;
    const tes = re.test(pwd)
    return tes
}

export const isValidPwdATTT = (pwd) => {
    if (!pwd) return false
    if (BLACK_LIST.some(item => pwd.toLowerCase().includes(item.toLowerCase()))) return false
    if (/(.)\1{2,}/.test(pwd)) return false
    for (let i = 0; i < pwd.length - 2; i++) {
        const a = pwd.charCodeAt(i), b = pwd.charCodeAt(i + 1), c = pwd.charCodeAt(i + 2)
        if (b === a + 1 && c === b + 1) return false
    }
    return true
}

export const isValidPwdATTTUsername = (pwd, userInfo) => {
    if (!pwd) return false
    if (typeof pwd === 'string' || pwd instanceof String) {
        const storeUserInfo = store.getState().userInfo.userInfo;
        const username = typeof userInfo === 'string'
            ? userInfo
            : userInfo?.username || storeUserInfo?.username || '';
        if (!username) return true;

        return !pwd?.toLowerCase()?.includes(username?.toLowerCase())
    }
    return false
}

export const isValidStringNotContainWhiteSpace = (pwd) => {
    if(!pwd) return false

    if (pwd?.includes(" ")) {
        return false;
    } else {
        return true;
    }
}

export const validateNewPwd = (formValues) => {
    let errors = [];
    if (!/^(?=.*[!@#$%^&*])/.test(formValues.newPwd)) errors.push("One_Special")
    if (!/^(?=.{8})/.test(formValues.newPwd)) errors.push("8_Characters")
    if (!/^(?=.*[0-9])/.test(formValues.newPwd)) errors.push("One_Number")
    if (!/^(?=.*[a-z])/.test(formValues.newPwd)) errors.push("One_Lowercase")
    if (!/^(?=.*[A-Z])/.test(formValues.newPwd)) errors.push("One_Uppercase")
    if (!isValidPwdATTT(formValues.newPwd)) errors.push("ATTT");
    if (!isValidPwdATTTUsername(formValues.newPwd)) errors.push("ATTT_username")
    if ((typeof formValues.newPwd === 'string' || formValues.newPwd instanceof String) && formValues.newPwd.localeCompare(formValues.currentPwd) === 0) errors.push("same_old_pw")
    return errors
}
